var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { domel } from '../utils/dom_elem_builder';
import { DateTimePicker } from './date_time_picker';
import { DefaultCalendar } from './default_calendar';
import { DefaultTimePicker } from './default_time_picker';
import { getElementAbsolutePos } from '../utils/ui-utils';
var DefaultDateTimePicker = /** @class */ (function (_super) {
    __extends(DefaultDateTimePicker, _super);
    function DefaultDateTimePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultDateTimePicker.prototype.render = function () {
        var _this = this;
        var sb = domel('div', document.body)
            .addClass("" + this.cssPrefix)
            .attr('tabIndex', '0')
            .setStyle('position', 'absolute')
            .setStyle('top', '-1000px')
            .setStyle('left', '-1000px')
            .on('keydown', function (ev) {
            if (ev.keyCode === 27) { // ESC is pressed
                _this.cancel();
            }
            else if (ev.keyCode === 13) { // Enter is pressed
                _this.apply(_this.getDateTime());
            }
            return false;
        });
        if (this.options.zIndex) {
            sb.setStyle('z-index', "" + this.options.zIndex);
        }
        this.slot = sb.toDOM();
        _super.prototype.render.call(this);
        this.renderButtons();
        this.globalMouseDownHandler = function (e) {
            var event = window.event || e;
            var o = event.srcElement || event.target;
            var isOutside = !_this.slot.contains(event.target);
            if (isOutside) {
                document.removeEventListener('mousedown', _this.globalMouseDownHandler, true);
                _this.cancel();
            }
            return true;
        };
    };
    DefaultDateTimePicker.prototype.renderButtons = function () {
        var _this = this;
        var builder = domel('div', this.slot)
            .addClass(this.cssPrefix + "-buttons")
            .addChild('button', function (b) { return _this.nowButton = b
            .addClass(_this.cssPrefix + "-button " + _this.cssPrefix + "-button-now")
            .text(i18n.getText('ButtonNow'))
            .on('click', function () {
            _this.setDateTime(new Date());
            _this.dateTimeChanged();
            return false;
        })
            .toDOM(); });
        if (this.options.showTimePicker || !this.options.oneClickDateSelection) {
            builder.addChild('button', function (b) { return _this.submitButton = b
                .addClass(_this.cssPrefix + "-button " + _this.cssPrefix + "-button-apply")
                .text(i18n.getText('ButtonApply'))
                .on('click', function () {
                _this.apply(_this.getDateTime());
                return false;
            })
                .toDOM(); });
        }
        builder.addChild('button', function (b) { return _this.submitButton = b
            .addClass(_this.cssPrefix + "-button " + _this.cssPrefix + "-button-cancel")
            .text(i18n.getText('ButtonCancel'))
            .on('click', function () {
            _this.cancel();
            return false;
        })
            .toDOM(); });
    };
    DefaultDateTimePicker.prototype.createCalendar = function (options) {
        this.calendarSlot =
            domel('div', this.slot)
                .addClass(this.cssPrefix + "-cal")
                .toDOM();
        return new DefaultCalendar(this.calendarSlot, options);
    };
    DefaultDateTimePicker.prototype.createTimePicker = function (options) {
        this.timePickerSlot =
            domel('div', this.slot)
                .addClass(this.cssPrefix + "-tp")
                .toDOM();
        return new DefaultTimePicker(this.timePickerSlot, options);
    };
    DefaultDateTimePicker.prototype.show = function (anchor) {
        var _this = this;
        if (this.options.showDateTimeInput) {
            if (this.options.beforeShow) {
                this.options.beforeShow();
            }
            var anchorPos = getElementAbsolutePos(anchor || document.body);
            var parentPos = getElementAbsolutePos(anchor ? anchor.parentElement || anchor : document.body);
            this.slot.style.top = parentPos.y + 'px';
            this.slot.style.left = anchorPos.x + 'px';
        }
        else {
            _super.prototype.show.call(this, anchor);
            this.slot.focus();
        }
        setTimeout(function () {
            document.addEventListener('mousedown', _this.globalMouseDownHandler, true);
        }, 1);
    };
    return DefaultDateTimePicker;
}(DateTimePicker));
export { DefaultDateTimePicker };
//# sourceMappingURL=default_date_time_picker.js.map